import React, { useState } from 'react';
import { SearchIcon, ChevronRightIcon, StepForwardIcon, PlusIcon, Settings2Icon } from 'lucide-react';
interface Service {
  id: string;
  title: string;
  description: string;
  category: string;
  subCategory: string;
  lastModified: string;
  status: 'active' | 'draft' | 'inactive';
}
const services: Service[] = [
// Land & Property Services
{
  id: 'lp1',
  title: 'New Land Title Registration Workflow',
  description: 'Process for registering new land titles',
  category: 'Land & Property Services',
  subCategory: 'Land Title Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp2',
  title: 'Land Title Transfer Workflow',
  description: 'Process for transferring land ownership',
  category: 'Land & Property Services',
  subCategory: 'Land Title Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp3',
  title: 'Land Title Rectification Workflow',
  description: 'Process for correcting land title information',
  category: 'Land & Property Services',
  subCategory: 'Land Title Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp4',
  title: 'Land Parcel Modification Workflow',
  description: 'Handles subdivision and amalgamation of land parcels',
  category: 'Land & Property Services',
  subCategory: 'Land Title Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp5',
  title: 'Land Lease Management Workflow',
  description: 'Handles new leases and renewals',
  category: 'Land & Property Services',
  subCategory: 'Land Title Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp6',
  title: 'Land Encumbrance Registration Workflow',
  description: 'Process for registering encumbrances on land',
  category: 'Land & Property Services',
  subCategory: 'Land Title Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp7',
  title: 'Building Permit Application Workflow',
  description: 'New construction permit process',
  category: 'Land & Property Services',
  subCategory: 'Property Development',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp8',
  title: 'Renovation/Extension Permit Workflow',
  description: 'Process for renovation and extension permits',
  category: 'Land & Property Services',
  subCategory: 'Property Development',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp9',
  title: 'Demolition Permit Workflow',
  description: 'Process for demolition permits',
  category: 'Land & Property Services',
  subCategory: 'Property Development',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp10',
  title: 'Occupancy Certificate Application Workflow',
  description: 'Process for occupancy certification',
  category: 'Land & Property Services',
  subCategory: 'Property Development',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp11',
  title: 'Minor Property Permit Workflow',
  description: 'For hoarding, scaffolding, address assignment',
  category: 'Land & Property Services',
  subCategory: 'Property Development',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'lp12',
  title: 'Property Information Certificate Workflow',
  description: 'For zoning certificates and valuation reports',
  category: 'Land & Property Services',
  subCategory: 'Property Development',
  lastModified: '2024-02-15',
  status: 'active'
},
// Municipal Taxes & Revenue
{
  id: 'tr1',
  title: 'Property Tax Exemption Application Workflow',
  description: 'Process for property tax exemption requests',
  category: 'Municipal Taxes & Revenue',
  subCategory: 'Tax Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'tr2',
  title: 'Service Fee Exemption Application Workflow',
  description: 'Process for service fee exemption requests',
  category: 'Municipal Taxes & Revenue',
  subCategory: 'Tax Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'tr3',
  title: 'Property Valuation Appeal Workflow',
  description: 'Process for appealing property valuations',
  category: 'Municipal Taxes & Revenue',
  subCategory: 'Tax Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'tr4',
  title: 'Tax Bill Dispute/Correction Workflow',
  description: 'Process for disputing or correcting tax bills',
  category: 'Municipal Taxes & Revenue',
  subCategory: 'Tax Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'tr5',
  title: 'Penalty/Interest Waiver Application Workflow',
  description: 'Process for requesting penalty/interest waivers',
  category: 'Municipal Taxes & Revenue',
  subCategory: 'Tax Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'tr6',
  title: 'Tax Clearance Certificate Application Workflow',
  description: 'Process for tax clearance certification',
  category: 'Municipal Taxes & Revenue',
  subCategory: 'Tax Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'tr7',
  title: 'Tax Payment Arrangement Workflow',
  description: 'Process for setting up payment arrangements',
  category: 'Municipal Taxes & Revenue',
  subCategory: 'Tax Management',
  lastModified: '2024-02-15',
  status: 'active'
},
// Business & Operational Licensing
{
  id: 'bl1',
  title: 'New Business License Application Workflow',
  description: 'Process for new business licenses',
  category: 'Business & Operational Licensing',
  subCategory: 'Business Licensing',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'bl2',
  title: 'Business License Renewal Workflow',
  description: 'Process for business license renewals',
  category: 'Business & Operational Licensing',
  subCategory: 'Business Licensing',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'bl3',
  title: 'Business License Amendment Workflow',
  description: 'Process for updating business license details',
  category: 'Business & Operational Licensing',
  subCategory: 'Business Licensing',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'bl4',
  title: 'Business License Cancellation Workflow',
  description: 'Process for canceling business licenses',
  category: 'Business & Operational Licensing',
  subCategory: 'Business Licensing',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'bl5',
  title: 'Signage Permit Application Workflow',
  description: 'Process for business signage permits',
  category: 'Business & Operational Licensing',
  subCategory: 'Specialized Permits',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'bl6',
  title: 'Specialized Business Permit Workflow',
  description: 'For liquor, accommodation, and tourism permits',
  category: 'Business & Operational Licensing',
  subCategory: 'Specialized Permits',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'bl7',
  title: 'Facility Health Permit Application Workflow',
  description: 'Process for health permits',
  category: 'Business & Operational Licensing',
  subCategory: 'Specialized Permits',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'bl8',
  title: 'Minor Environmental Permit Workflow',
  description: 'Environmental permits for businesses',
  category: 'Business & Operational Licensing',
  subCategory: 'Specialized Permits',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'bl9',
  title: 'Public Transportation Operator Permit Workflow',
  description: 'Process for transport operator permits',
  category: 'Business & Operational Licensing',
  subCategory: 'Transportation',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'bl10',
  title: 'Street Vendor Permit Application Workflow',
  description: 'Process for street vendor permits',
  category: 'Business & Operational Licensing',
  subCategory: 'Specialized Permits',
  lastModified: '2024-02-15',
  status: 'active'
},
// Waste Management Services
{
  id: 'wm1',
  title: 'Waste Service Management Workflow',
  description: 'For registrations, updates, and bin requests',
  category: 'Waste Management Services',
  subCategory: 'Service Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'wm2',
  title: 'Bulk Waste Pickup Request Workflow',
  description: 'Process for bulk waste collection requests',
  category: 'Waste Management Services',
  subCategory: 'Service Requests',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'wm3',
  title: 'Missed Waste Collection Reporting Workflow',
  description: 'Process for reporting missed collections',
  category: 'Waste Management Services',
  subCategory: 'Service Requests',
  lastModified: '2024-02-15',
  status: 'active'
},
// Water & Sanitation Services
{
  id: 'ws1',
  title: 'New Utility Connection Workflow',
  description: 'Process for new water and sewer connections',
  category: 'Water & Sanitation Services',
  subCategory: 'Utility Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ws2',
  title: 'Utility Service Issue Reporting Workflow',
  description: 'Process for reporting utility issues',
  category: 'Water & Sanitation Services',
  subCategory: 'Service Issues',
  lastModified: '2024-02-15',
  status: 'active'
},
// Infrastructure & Transportation
{
  id: 'it1',
  title: 'Residential Parking Permit Workflow',
  description: 'Process for residential parking permits',
  category: 'Infrastructure & Transportation',
  subCategory: 'Parking Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'it2',
  title: 'Temporary Road/Infrastructure Use Permit Workflow',
  description: 'Process for temporary road closure permits',
  category: 'Infrastructure & Transportation',
  subCategory: 'Infrastructure Use',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'it3',
  title: 'Infrastructure Defect Reporting Workflow',
  description: 'Process for reporting infrastructure issues',
  category: 'Infrastructure & Transportation',
  subCategory: 'Maintenance',
  lastModified: '2024-02-15',
  status: 'active'
},
// Public Safety & Compliance
{
  id: 'ps1',
  title: 'Fire Safety Certificate Application Workflow',
  description: 'Process for fire safety certification',
  category: 'Public Safety & Compliance',
  subCategory: 'Safety Certification',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ps2',
  title: 'Security Alarm Permit Workflow',
  description: 'Process for security alarm permits',
  category: 'Public Safety & Compliance',
  subCategory: 'Permits',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ps3',
  title: 'Public Event/Gathering Permit Workflow',
  description: 'Process for public event permits',
  category: 'Public Safety & Compliance',
  subCategory: 'Event Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ps4',
  title: 'Bylaw Complaint Investigation Workflow',
  description: 'Internal process for bylaw complaints',
  category: 'Public Safety & Compliance',
  subCategory: 'Internal Processes',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ps5',
  title: 'Animal Control Service Dispatch Workflow',
  description: 'Internal process for animal control',
  category: 'Public Safety & Compliance',
  subCategory: 'Internal Processes',
  lastModified: '2024-02-15',
  status: 'active'
},
// Family & Civil Status
{
  id: 'cs1',
  title: 'Birth Registration & Certificate Workflow',
  description: 'Process for birth registration and certification',
  category: 'Family & Civil Status',
  subCategory: 'Vital Records',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'cs2',
  title: 'Marriage Registration & Certificate Workflow',
  description: 'Process for marriage registration',
  category: 'Family & Civil Status',
  subCategory: 'Vital Records',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'cs3',
  title: 'Death Registration & Certificate Workflow',
  description: 'Process for death registration',
  category: 'Family & Civil Status',
  subCategory: 'Vital Records',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'cs4',
  title: 'Proof of Residency/Address Certificate Workflow',
  description: 'Process for residency certification',
  category: 'Family & Civil Status',
  subCategory: 'Certificates',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'cs5',
  title: 'Family Composition Certificate Workflow',
  description: 'Process for family composition certification',
  category: 'Family & Civil Status',
  subCategory: 'Certificates',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'cs6',
  title: 'Personal Record Update Workflow',
  description: 'Process for updating personal records',
  category: 'Family & Civil Status',
  subCategory: 'Record Management',
  lastModified: '2024-02-15',
  status: 'active'
},
// Health Services
{
  id: 'hs1',
  title: 'Special Event Food Vendor Permit Workflow',
  description: 'Process for temporary food vendor permits',
  category: 'Health Services',
  subCategory: 'Food Safety',
  lastModified: '2024-02-15',
  status: 'active'
},
// Social Services
{
  id: 'ss1',
  title: 'Social Assistance Application Workflow',
  description: 'Process for social assistance applications',
  category: 'Social Services',
  subCategory: 'Assistance Programs',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ss2',
  title: 'Subsidized Housing Application Workflow',
  description: 'Process for housing assistance',
  category: 'Social Services',
  subCategory: 'Housing',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ss3',
  title: 'Community Program Registration Workflow',
  description: 'Process for program registration',
  category: 'Social Services',
  subCategory: 'Community Programs',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ss4',
  title: 'Community Project Grant Application Workflow',
  description: 'Process for community grant applications',
  category: 'Social Services',
  subCategory: 'Grants',
  lastModified: '2024-02-15',
  status: 'active'
},
// Education Services
{
  id: 'ed1',
  title: 'School Facility Use Permit Workflow',
  description: 'Process for school facility usage',
  category: 'Education Services',
  subCategory: 'Facility Use',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ed2',
  title: 'Foreign Qualification Equivalency Workflow',
  description: 'Process for qualification assessment',
  category: 'Education Services',
  subCategory: 'Qualifications',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ed3',
  title: 'Educational Institution Accreditation Workflow',
  description: 'Process for institution accreditation',
  category: 'Education Services',
  subCategory: 'Accreditation',
  lastModified: '2024-02-15',
  status: 'active'
},
// Environmental Services
{
  id: 'env1',
  title: 'Environmental Permit Application Workflow',
  description: 'Process for environmental permits',
  category: 'Environmental Services',
  subCategory: 'Permits',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'env2',
  title: 'Water Usage Permit Workflow',
  description: 'Process for water usage permits',
  category: 'Environmental Services',
  subCategory: 'Water Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'env3',
  title: 'Tree Management Permit Workflow',
  description: 'Process for tree removal/forestry permits',
  category: 'Environmental Services',
  subCategory: 'Forestry',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'env4',
  title: 'Environmental Violation Reporting Workflow',
  description: 'Internal process for violation reports',
  category: 'Environmental Services',
  subCategory: 'Compliance',
  lastModified: '2024-02-15',
  status: 'active'
},
// Agriculture & Natural Resources
{
  id: 'ag1',
  title: 'Agricultural Land Use Permit Workflow',
  description: 'Process for agricultural land use',
  category: 'Agriculture & Natural Resources',
  subCategory: 'Land Use',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ag2',
  title: 'Livestock Keeping Permit Workflow',
  description: 'Process for livestock permits',
  category: 'Agriculture & Natural Resources',
  subCategory: 'Livestock',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'ag3',
  title: 'Seasonal Burn Permit Workflow',
  description: 'Process for seasonal burning permits',
  category: 'Agriculture & Natural Resources',
  subCategory: 'Permits',
  lastModified: '2024-02-15',
  status: 'active'
},
// Culture & Recreation
{
  id: 'cr1',
  title: 'Facility Booking & Park Permit Workflow',
  description: 'Process for facility and park bookings',
  category: 'Culture & Recreation',
  subCategory: 'Facility Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'cr2',
  title: 'Program Registration Workflow',
  description: 'Process for program registration',
  category: 'Culture & Recreation',
  subCategory: 'Programs',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'cr3',
  title: 'Volunteer Application Workflow',
  description: 'Process for volunteer applications',
  category: 'Culture & Recreation',
  subCategory: 'Volunteering',
  lastModified: '2024-02-15',
  status: 'active'
},
// Transportation & Driving
{
  id: 'td1',
  title: 'Driving License Application Workflow',
  description: 'Process for new driving licenses',
  category: 'Transportation & Driving',
  subCategory: 'Licensing',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'td2',
  title: 'Driving License Renewal Workflow',
  description: 'Process for license renewals',
  category: 'Transportation & Driving',
  subCategory: 'Licensing',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'td3',
  title: 'Vehicle Registration Workflow',
  description: 'Process for new vehicle registration',
  category: 'Transportation & Driving',
  subCategory: 'Vehicle Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'td4',
  title: 'Vehicle Annual Renewal/Inspection Workflow',
  description: 'Process for vehicle renewals and inspections',
  category: 'Transportation & Driving',
  subCategory: 'Vehicle Management',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'td5',
  title: 'Commercial Vehicle Route Permit Workflow',
  description: 'Process for commercial vehicle routes',
  category: 'Transportation & Driving',
  subCategory: 'Commercial Transport',
  lastModified: '2024-02-15',
  status: 'active'
},
// Governance & Civic Engagement
{
  id: 'gc1',
  title: 'Public Records Request Workflow',
  description: 'Process for public records requests',
  category: 'Governance & Civic Engagement',
  subCategory: 'Public Records',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'gc2',
  title: 'Board/Committee Application Workflow',
  description: 'Process for board/committee applications',
  category: 'Governance & Civic Engagement',
  subCategory: 'Participation',
  lastModified: '2024-02-15',
  status: 'active'
}, {
  id: 'gc3',
  title: 'Service Feedback/Complaint Resolution Workflow',
  description: 'Process for handling feedback and complaints',
  category: 'Governance & Civic Engagement',
  subCategory: 'Feedback Management',
  lastModified: '2024-02-15',
  status: 'active'
}];
const CategoryIcon = ({
  category
}: {
  category: string;
}) => {
  switch (category) {
    case 'Land & Property Services':
      return <div className="h-6 w-6 text-blue-600" data-id="element-3097" />;
    case 'Municipal Taxes & Revenue':
      return <div className="h-6 w-6 text-purple-600" data-id="element-3098" />;
    case 'Business & Operational Licensing':
      return <div className="h-6 w-6 text-green-600" data-id="element-3099" />;
    case 'Civil Status & Records':
      return <div className="h-6 w-6 text-red-600" data-id="element-3100" />;
    default:
      return <Settings2Icon className="h-6 w-6 text-gray-600" data-id="element-3101" />;
  }
};
const ServiceCard = ({
  service
}: {
  service: Service;
}) => {
  return <div className="bg-white rounded-lg border border-gray-200 hover:border-blue-500 hover:shadow-sm transition-all duration-200" data-id="element-3102">
      <div className="p-5 flex flex-col h-full" data-id="element-3103">
        <div className="flex-1" data-id="element-3104">
          <div className="flex justify-between items-center mb-3" data-id="element-3105">
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-3106">
              {service.title}
            </h3>
            <span className={`px-2 py-1 text-xs rounded-full ${service.status === 'active' ? 'bg-green-100 text-green-800' : service.status === 'draft' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`} data-id="element-3107">
              {service.status.charAt(0).toUpperCase() + service.status.slice(1)}
            </span>
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-3108">{service.description}</p>
        </div>
        <div className="space-y-4" data-id="element-3109">
          <div className="flex items-center text-sm text-gray-500 pt-4 border-t border-gray-100" data-id="element-3110">
            <span data-id="element-3111">Last modified: {service.lastModified}</span>
          </div>
          <div className="flex justify-end space-x-2" data-id="element-3112">
            <button className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-3113">
              Edit
            </button>
            <button className="px-3 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-3114">
              Configure
            </button>
          </div>
        </div>
      </div>
    </div>;
};
const CategorySection = ({
  category,
  services
}: {
  category: string;
  services: Service[];
}) => {
  return <div className="mb-12" data-id="element-3115">
      <div className="flex items-center justify-between mb-6" data-id="element-3116">
        <div className="flex items-center" data-id="element-3117">
          <h2 className="text-xl font-semibold text-gray-900 ml-2" data-id="element-3118">
            {category} ({services.length})
          </h2>
        </div>
        <button className="flex items-center px-3 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-3119">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-3120" />
          Add New Workflow
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3121">
        {services.map(service => <ServiceCard key={service.id} service={service} data-id="element-3122" />)}
      </div>
    </div>;
};
export const WorkflowConfigurationPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const filteredServices = services.filter(service => service.title.toLowerCase().includes(searchQuery.toLowerCase()) || service.description.toLowerCase().includes(searchQuery.toLowerCase()));
  const categories = Array.from(new Set(filteredServices.map(service => service.category)));
  return <div className="min-h-screen bg-gray-50" data-id="element-3123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3124">
        {/* Breadcrumb */}
        <div className="flex items-center text-sm text-gray-500 mb-8" data-id="element-3125">
          <a href="/" className="hover:text-gray-700" data-id="element-3126">
            Dashboard
          </a>
          <ChevronRightIcon className="h-4 w-4 mx-2" data-id="element-3127" />
          <a href="/admin" className="hover:text-gray-700" data-id="element-3128">
            Administration
          </a>
          <ChevronRightIcon className="h-4 w-4 mx-2" data-id="element-3129" />
          <span className="text-gray-900" data-id="element-3130">Workflow Configuration</span>
        </div>
        {/* Header with Stats */}
        <div className="mb-8" data-id="element-3131">
          <div className="flex justify-between items-start mb-4" data-id="element-3132">
            <div data-id="element-3133">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-3134">
                Workflow Configuration
              </h1>
              <p className="mt-1 text-sm text-gray-500" data-id="element-3135">
                Configure and manage municipal service workflows across all
                departments
              </p>
            </div>
            <div className="flex items-center space-x-3" data-id="element-3136">
              <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-3137">
                Import Workflows
              </button>
              <button className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-3138">
                Create New Workflow
              </button>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4" data-id="element-3139">
            <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-3140">
              <div className="text-sm text-gray-500" data-id="element-3141">Total Workflows</div>
              <div className="text-2xl font-semibold text-gray-900" data-id="element-3142">
                {services.length}
              </div>
            </div>
            <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-3143">
              <div className="text-sm text-gray-500" data-id="element-3144">Active Workflows</div>
              <div className="text-2xl font-semibold text-green-600" data-id="element-3145">
                {services.filter(s => s.status === 'active').length}
              </div>
            </div>
            <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-3146">
              <div className="text-sm text-gray-500" data-id="element-3147">Draft Workflows</div>
              <div className="text-2xl font-semibold text-yellow-600" data-id="element-3148">
                {services.filter(s => s.status === 'draft').length}
              </div>
            </div>
            <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-3149">
              <div className="text-sm text-gray-500" data-id="element-3150">Service Categories</div>
              <div className="text-2xl font-semibold text-blue-600" data-id="element-3151">
                {Array.from(new Set(services.map(s => s.category))).length}
              </div>
            </div>
          </div>
        </div>
        {/* Enhanced Search and Filters */}
        <div className="mb-8 bg-white p-4 rounded-lg border border-gray-200" data-id="element-3152">
          <div className="flex flex-col md:flex-row md:items-center md:space-x-4" data-id="element-3153">
            <div className="flex-1" data-id="element-3154">
              <div className="relative" data-id="element-3155">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3156">
                  <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-3157" />
                </div>
                <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Search workflows by name, category, or description..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-3158" />
              </div>
            </div>
            <div className="mt-4 md:mt-0 flex space-x-4" data-id="element-3159">
              <select className="block w-full md:w-auto px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-3160">
                <option value="" data-id="element-3161">All Categories</option>
                {categories.map(cat => <option key={cat} value={cat} data-id="element-3162">
                    {cat}
                  </option>)}
              </select>
              <select className="block w-full md:w-auto px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-3163">
                <option value="" data-id="element-3164">All Statuses</option>
                <option value="active" data-id="element-3165">Active</option>
                <option value="draft" data-id="element-3166">Draft</option>
                <option value="inactive" data-id="element-3167">Inactive</option>
              </select>
            </div>
          </div>
          {searchQuery && <div className="mt-2 text-sm text-gray-500" data-id="element-3168">
              Found {filteredServices.length} workflows matching your search
            </div>}
        </div>
        {/* Service Categories */}
        {categories.map(category => <CategorySection key={category} category={category} services={filteredServices.filter(service => service.category === category)} data-id="element-3169" />)}
        {/* No Results */}
        {filteredServices.length === 0 && <div className="text-center py-12" data-id="element-3170">
            <div className="text-gray-400 mb-2" data-id="element-3171">
              <SearchIcon className="h-12 w-12 mx-auto" data-id="element-3172" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-3173">
              No workflows found
            </h3>
            <p className="text-gray-500" data-id="element-3174">
              Try adjusting your search or filters to find what you're looking
              for.
            </p>
          </div>}
      </div>
    </div>;
};